/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetParkingCloseRequestApiFrom } from '../../models/set-parking-close-request-api-from';

export interface ApiV3ServiceSetParkingClosePost$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: SetParkingCloseRequestApiFrom
}

export function apiV3ServiceSetParkingClosePost(http: HttpClient, rootUrl: string, params?: ApiV3ServiceSetParkingClosePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceSetParkingClosePost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV3ServiceSetParkingClosePost.PATH = '/api/v3/service/SetParkingClose';
